/**
 * Brandner Project Sort
 *
 * Handles client-side sorting on auction project pages (no page reload)
 *
 * @package Brandner_Custom
 * @since 1.1.0
 */

document.addEventListener('DOMContentLoaded', function() {
    var sortSelect = document.getElementById('auction-sort');

    if (!sortSelect) {
        return;
    }

    var DEFAULT_SORT = 'end_date-asc';

    function isKnownSort(value) {
        return Array.prototype.some.call(sortSelect.options, function(opt) {
            return opt.value === value;
        });
    }

    /**
     * Sortier-Daten eines Lot-Elements aus der serverseitig gerenderten Map.
     */
    function sortDataFor(li) {
        var match = li.className.match(/post-(\d+)/);
        var id = match ? match[1] : null;

        return (id && typeof productSortData !== 'undefined' && productSortData[id])
            ? productSortData[id]
            : {};
    }

    /**
     * Comparator fuer eine Sortier-Auswahl ("feld-richtung").
     *
     * Muss 1:1 der PHP-Sortierung in templates/taxonomy-auction-project.php
     * entsprechen — laufen die beiden auseinander, zeigt die Seite nach einem
     * Reload eine andere Reihenfolge als das Dropdown behauptet.
     */
    function makeComparator(sortValue) {
        var parts = sortValue.split('-');
        var field = parts[0];  // end_date, current_bid, lowest_price, sku, bid_count
        var order = parts[1];  // asc oder desc

        return function(a, b) {
            var dataA = sortDataFor(a);
            var dataB = sortDataFor(b);

            // Beendete Auktionen immer ans Ende (bei end_date + current_bid Sortierung)
            if (field === 'end_date' || field === 'current_bid') {
                var endedA = dataA.is_ended || false;
                var endedB = dataB.is_ended || false;

                if (endedA && !endedB) return 1;  // A beendet -> nach hinten
                if (!endedA && endedB) return -1; // B beendet -> nach hinten
                // Beide beendet oder beide aktiv -> normal sortieren
            }

            // Sortier-Werte holen
            var valA, valB;
            if (field === 'sku') {
                // Losnummer numerisch sortieren
                valA = parseInt(dataA['lot_number']) || 0;
                valB = parseInt(dataB['lot_number']) || 0;
            } else if (field === 'current_bid' || field === 'start_price' || field === 'lowest_price' || field === 'bid_count') {
                valA = parseFloat(dataA[field]) || 0;
                valB = parseFloat(dataB[field]) || 0;
            } else if (field === 'end_date') {
                // STABIL nach geplantem Ende sortieren (nicht nach dem per Anti-Snipe
                // verlaengerten Ende) — konsistent mit der PHP-Sortierung.
                valA = dataA['scheduled_end'] || dataA['end_date'] || '';
                valB = dataB['scheduled_end'] || dataB['end_date'] || '';
            } else {
                valA = dataA[field] || '';
                valB = dataB[field] || '';
            }

            // Vergleich
            var result;
            if (valA < valB) {
                result = -1;
            } else if (valA > valB) {
                result = 1;
            } else {
                result = 0;
            }

            // Gleichstand -> Tiebreak ueber die Losnummer. Muss identisch zur
            // PHP-Sortierung in taxonomy-auction-project.php sein, sonst weicht
            // die Reihenfolge nach einem Reload ab (viele Lose teilen sich z.B.
            // Gebot 0).
            if (result === 0) {
                var lotA = parseInt(dataA['lot_number']) || 0;
                var lotB = parseInt(dataB['lot_number']) || 0;
                result = lotA < lotB ? -1 : (lotA > lotB ? 1 : 0);
            }

            // Reihenfolge umkehren bei desc
            return order === 'desc' ? -result : result;
        };
    }

    /**
     * Liste in die gewuenschte Reihenfolge bringen.
     *
     * Gibt true zurueck, wenn dafuer tatsaechlich umsortiert werden musste —
     * der Aufrufer kann sich das Neurechnen von Filter/Pagination sparen, wenn
     * der Server bereits richtig geliefert hat.
     */
    function applySort(sortValue) {
        var container = document.querySelector('ul.products');
        if (!container) return false;

        var products = Array.prototype.slice.call(container.querySelectorAll('li.product'));
        if (products.length < 2) return false;

        var sorted = products.slice().sort(makeComparator(sortValue));

        var changed = sorted.some(function(li, i) {
            return li !== products[i];
        });
        if (!changed) return false;

        // DOM neu anordnen (appendChild verschiebt existierende Elemente)
        sorted.forEach(function(product) {
            container.appendChild(product);
        });

        return true;
    }

    function writeSortToURL(sortValue) {
        var freshParams = new URLSearchParams(window.location.search);
        if (sortValue === DEFAULT_SORT) {
            freshParams.delete('sort');
        } else {
            freshParams.set('sort', sortValue);
        }
        var qs = freshParams.toString();
        history.replaceState(null, '', qs ? '?' + qs : window.location.pathname);
    }

    // =====================================================================
    // EFFEKTIVE SORTIERUNG BESTIMMEN
    // Reihenfolge der Quellen: URL > gemerkter Durchstoeber-Zustand > Default.
    // Der gemerkte Zustand deckt den Weg ab, der die Sortierung bisher
    // verschluckt hat: von der Produktseite ueber "Projekt ansehen" zurueck —
    // dieser Link zeigt auf die nackte Projekt-URL ohne ?sort=.
    // =====================================================================
    var urlSort = new URLSearchParams(window.location.search).get('sort');
    var browse = window.BrandnerProjectBrowse || null;
    var remembered = (browse && browse.pending && browse.pending.sort) ? browse.pending.sort : null;

    var currentSort = DEFAULT_SORT;
    if (urlSort && isKnownSort(urlSort)) {
        currentSort = urlSort;
    } else if (remembered && isKnownSort(remembered)) {
        currentSort = remembered;
    }

    sortSelect.value = currentSort;

    // Liste gegen die Auswahl pruefen und notfalls nachziehen. Der Server hat
    // in der Regel schon richtig sortiert; der Abgleich faengt die Faelle ab,
    // in denen die URL keine Sortierung trug (Rueckweg ueber "Projekt ansehen")
    // oder ein Cache eine Seite in Default-Reihenfolge ausgeliefert hat.
    var reordered = applySort(currentSort);

    if (urlSort !== currentSort && !(urlSort === null && currentSort === DEFAULT_SORT)) {
        writeSortToURL(currentSort);
    }

    if (reordered) {
        // Pagination/Filter neu rechnen, aber die Seite NICHT auf 1 zuruecksetzen —
        // beim Laden soll die Seite aus URL bzw. Durchstoeber-Zustand gelten.
        document.dispatchEvent(new CustomEvent('project:sorted', {
            detail: { initial: true }
        }));
    }

    // Bei Aenderung: Client-seitige Sortierung (ohne Reload)
    sortSelect.addEventListener('change', function() {
        var sortValue = this.value;

        applySort(sortValue);
        writeSortToURL(sortValue);

        // Pagination ueber Sortier-Aenderung informieren
        document.dispatchEvent(new CustomEvent('project:sorted', {
            detail: { initial: false }
        }));
    });
});
